import { httpClient } from "../../../shared/api/httpClient";
import type {
  CustomerLineOptionResponse,
  RepresentativeLineResponse,
} from "../model/types";

export const fetchCustomerLineOptions = async (): Promise<
  CustomerLineOptionResponse[]
> => {
  const response = await httpClient.get<CustomerLineOptionResponse[]>(
    "/line-users/customer-options",
  );
  return response.data;
};

export const fetchLineUsersByCustomer = async (
  mtCode: string,
  branchCode = "",
): Promise<RepresentativeLineResponse[]> => {
  const response = await httpClient.get<RepresentativeLineResponse[]>(
    "/line-users/by-customer",
    {
      params: { mt_code: mtCode.trim(), branch_code: branchCode.trim() },
    },
  );
  return response.data;
};
